// Helpers for showing webhook delivery health (rows from GET /api/admin/webhooks/status)

export const PLATFORM_NAMES = {
  shopify: 'Shopify',
  woocommerce: 'WooCommerce',
  bigcommerce: 'BigCommerce',
  wix: 'Wix',
  etsy: 'Etsy',
  amazon: 'Amazon',
  ebay: 'eBay',
};

// Timestamps are stored in UTC without a zone
export const parseUtc = (value) => new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(value) ? value : `${value}Z`);

export function timeAgo(value) {
  if (!value) return 'never';
  const seconds = Math.max(0, Math.round((Date.now() - parseUtc(value)) / 1000));
  if (seconds < 60) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours} h ago`;
  return `${Math.round(hours / 24)} days ago`;
}

// The most recent delivery failed (a later success resets consecutive_failures)
export const isFailing = (row) => row?.consecutive_failures > 0;
